import { Distrolist } from './distrolist.types';

export enum INVITE_CATEGORIES {
  INDIVIDUALS = 'Individuals',
  DISTROLISTS = 'Distrolists',
  COMMUNITIES = 'Communities',
  IMPORT = 'Import'
}

interface Invite {
  isInvited?: boolean;
  isInvitedInDB?: boolean;
  isInvalid?: boolean;
  currentStatus?: string;
}

export interface UserInvite extends Invite {
  email: string;
  id?: string;
  firstName?: string;
  lastName?: string;
}

export interface DistrolistInvite extends Distrolist, Invite {}

/** A community a host can invite to an event. `memberCount` counts active members only. */
export interface InvitableCommunity {
  id: number;
  name: string;
  privacy?: string;
  memberCount: number;
}

export interface CommunityInvite extends InvitableCommunity, Invite {}

export interface EditableInvites {
  userInvitesToAdd?: UserInvite[];
  addedInvitedUserIds?: number[];
  removedInvitedUserIds?: string[];
  distrolistInvitees?: DistrolistInvite[];
  distrolistInviteeIds?: number[];
  clearAllPreviousInvitees?: boolean;
  userInviteeCount?: number;
  isInviteOn?: boolean;
}
